export default {"src":"/_next/static/media/lrc.29552026.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};